<button
  class="bg-[#38971F] text-[#FFFFFF] text-[16px] h-[45px] !w-full"
  [type]="type"
  (click)="handleClick()"
  [ngClass]="btnClass"
  [class.disabled]="disabled"
  [disabled]="disabled"
>
  {{ buttonText }}
</button>
